export default {
    text: 'text',
    dash: 'dash',
};